<template>
  <div>
    <headers>
      <div class="header-main">
        <h1>{{ $t("home.header.hello1") }}</h1>
        <h2>{{ $t("home.header.hello2") }}</h2>
        <img class="mini-qrcode" src="https://static3.freshin.online/sku/jcjUHPoDuNxfBBxMMxyjXZfTvIQ%3D" alt />
        <p>{{ $t("home.header.hello3") }}</p>
      </div>
    </headers>
    <section class="main container">
      <div class="main-top">
        <ul class="main-top-ul">
          <li>
            <img src="https://static3.freshin.online/sku/NZN7P9JcJvvuy-OPzCCounuIDmc%3D" alt />
            <p>{{ $t("home.main.main-top-li1") }}</p>
          </li>
          <li>
            <img src="https://static3.freshin.online/sku/im7HpeXJnJZZpZp9v9yU%2B2Lxl7M%3D" alt />
            <p>{{ $t("home.main.main-top-li2") }}</p>
          </li>
          <li>
            <img src="https://static3.freshin.online/sku/rRpHnA1VvKwDPoQTRIMrgVmUJsg%3D" alt />
            <p>{{ $t("home.main.main-top-li3") }}</p>
          </li>
        </ul>
      </div>
      <div class="main-middle">
        <section class="main-middle-block">
          <h1>{{ $t("home.main.main-middle1.title") }}</h1>
          <h2>{{ $t("home.main.main-middle1.subtitle") }}</h2>
          <div class="main-middle-block-b">
            <div class="main-middle-block-img">
              <img src="https://static3.freshin.online/sku/KAno-d5mTEPiqYhD%2B%2B9SiCKdc9c%3D" alt />
            </div>
            <div class="main-middle-block-text">
              <div>
                <h1>{{ $t("home.main.main-middle1.product1.name") }}</h1>
                <p>{{ $t("home.main.main-middle1.product1.p1") }}</p>
                <p>{{ $t("home.main.main-middle1.product1.p2") }}</p>
                <p>{{ $t("home.main.main-middle1.product1.p3") }}</p>
              </div>
            </div>
          </div>
          <div class="main-middle-block-b">
            <div class="main-middle-block-img">
              <img src="https://static3.freshin.online/sku/tVD-Di6k8bZkFOf36V2Fqdy%2B22g%3D" alt />
            </div>
            <div class="main-middle-block-text order-first">
              <div>
                <h1>{{ $t("home.main.main-middle1.product2.name") }}</h1>
                <p>{{ $t("home.main.main-middle1.product2.p1") }}</p>
                <p>{{ $t("home.main.main-middle1.product2.p2") }}</p>
              </div>
            </div>
          </div>
        </section>
        <section class="main-middle-block">
          <h1>{{ $t("home.main.main-middle2.title") }}</h1>
          <h2>{{ $t("home.main.main-middle2.subtitle") }}</h2>
          <div class="main-middle-block-b">
            <div class="main-middle-block-img">
              <img src="https://static3.freshin.online/sku/Pb0wJwR%2BILGL2aYjsBGCMFe2bhA%3D" alt />
            </div>
            <div class="main-middle-block-text">
              <div>
                <h1>{{ $t("home.main.main-middle2.product1.name") }}</h1>
                <p>{{ $t("home.main.main-middle2.product1.p1") }}</p>
                <p>{{ $t("home.main.main-middle2.product1.p2") }}</p>
                <p>{{ $t("home.main.main-middle2.product1.p3") }}</p>
              </div>
            </div>
          </div>
          <div class="main-middle-block-b">
            <div class="main-middle-block-img">
              <img src="https://static3.freshin.online/sku/xEsHmNCOy9wpWvutvGDFUn-iplU%3D" alt />
            </div>
            <div class="main-middle-block-text order-first">
              <div>
                <h1>{{ $t("home.main.main-middle2.product2.name") }}</h1>
                <p>{{ $t("home.main.main-middle2.product2.p1") }}</p>
                <p>{{ $t("home.main.main-middle2.product2.p2") }}</p>
                <p>{{ $t("home.main.main-middle2.product2.p3") }}</p>
              </div>
            </div>
          </div>
        </section>
        <section class="main-middle-block">
          <h1>{{ $t("home.main.main-middle3.title") }}</h1>
          <h2>{{ $t("home.main.main-middle3.subtitle") }}</h2>
          <div class="main-middle-block-b">
            <div class="main-middle-block-img">
              <img src="https://static3.freshin.online/sku/IZyNPgBTIY-NlKwewII2o8eB9JI%3D" alt />
            </div>
            <div class="main-middle-block-text">
              <div>
                <h1>{{ $t("home.main.main-middle3.product1.name") }}</h1>
                <p>{{ $t("home.main.main-middle3.product1.p1") }}</p>
                <p>{{ $t("home.main.main-middle3.product1.p2") }}</p>
                <p>{{ $t("home.main.main-middle3.product1.p3") }}</p>
              </div>
            </div>
          </div>
          <div class="main-middle-block-b">
            <div class="main-middle-block-img">
              <img src="https://static3.freshin.online/sku/n4UN%2BtHBMld0N2UmrjYOn1buvnU%3D" alt />
            </div>
            <div class="main-middle-block-text order-first">
              <div>
                <h1>{{ $t("home.main.main-middle3.product2.name") }}</h1>
                <p>{{ $t("home.main.main-middle3.product2.p1") }}</p>
                <p>{{ $t("home.main.main-middle3.product2.p2") }}</p>
                <p>{{ $t("home.main.main-middle3.product2.p3") }}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="main-bottom">
        <div>
          <h1>鲜入为主深耕全球优质供应链，精选上千款生鲜产品</h1>
          <h1>致同样在用心生活的你</h1>
          <div class="main-bottom-img">
            <img src="https://static3.freshin.online/sku/OlqWDB6hfyAolhCLLx%2BKbsjLbiU%3D" alt />
            <img src="https://static3.freshin.online/sku/QeY02TP1AdQgYbz4soyRfiPbqbs%3D" alt />
            <img src="https://static3.freshin.online/sku/NFluZ2VeF2dbHiJDTd8Rbr7eoJM%3D" alt />
          </div>
        </div>
        <div class="main-bottom-bro">
          <h1>合作伙伴</h1>
          <div
            v-show="broNavActive==index"
            v-for="(item,index) in broList"
            :key="index"
            class="main-bottom-bro-main"
          >
            <img :src="item.img" alt />
            <p v-html="item.text"></p>
          </div>
          <ul class="main-bottom-bro-ul">
            <li
              @click.stop="changeindex(index)"
              v-for="(item,index) in broNavList"
              :key="index"
              :class="{broNavListActive:broNavActive==index}"
            >
              <img :src="item.img" alt />
              <span>{{item.text}}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <footers showMore="true"></footers>
  </div>
</template>

<script>
export default {
  data() {
    return {
      broNavActive: 0,
      broNavList: [
        {
          img: "https://static3.freshin.online/sku/KL-9zsTaiaFOL-lgSEagD1Arjag%3D",
          text: "Kansom"
        },
        {
          img: "https://static3.freshin.online/sku/-bMUep%2Bu8FcO6PrhQCLTRTCeEx4%3D",
          text: "A2"
        },
        {
          img: "https://static3.freshin.online/sku/RHdFEtvqfn%2BbPKoUBeN4N8LTuNo%3D",
          text: "Dairy farmers"
        },
        {
          img: "https://static3.freshin.online/sku/j2c2h0TAzBwvF8S1KkKpD1Sav6A%3D",
          text: "ARNOTTS"
        },
        {
          img: "https://static3.freshin.online/sku/DgAz12vfrbvmhR-%2BhJzwxNsjrag%3D",
          text: "Newlait纽兰特"
        },
        {
          img: "https://static3.freshin.online/sku/IqhVkSH-y3-PU92tNEl8D4TyeQE%3D",
          text: "go ahead"
        },
        {
          img: "https://static3.freshin.online/sku/R-bkKOHMCtqp0BVuDovGi%2Bs%2BlQo%3D",
          text: "single estate dairy单甄"
        }
      ]
    };
  },
  computed: {
    broList() {
      return [
        {
          img: "https://static3.freshin.online/sku/KL-9zsTaiaFOL-lgSEagD1Arjag%3D",
          text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.kansom")
        },
        {
          img: "https://static3.freshin.online/sku/-bMUep%2Bu8FcO6PrhQCLTRTCeEx4%3D",
          text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.a2")
        },
        {
          img: "https://static3.freshin.online/sku/RHdFEtvqfn%2BbPKoUBeN4N8LTuNo%3D",
          text: this.$t(
            "home.main.main-bottom-bro.main-bottom-bro-main.dairyfarmers"
          )
        },
        {
          img: "https://static3.freshin.online/sku/j2c2h0TAzBwvF8S1KkKpD1Sav6A%3D",
          text: this.$t(
            "home.main.main-bottom-bro.main-bottom-bro-main.arnotts"
          )
        },
        {
          img: "https://static3.freshin.online/sku/DgAz12vfrbvmhR-%2BhJzwxNsjrag%3D",
          text: this.$t(
            "home.main.main-bottom-bro.main-bottom-bro-main.newlait"
          )
        },
        {
          img: "https://static3.freshin.online/sku/IqhVkSH-y3-PU92tNEl8D4TyeQE%3D",
          text: this.$t(
            "home.main.main-bottom-bro.main-bottom-bro-main.goahead"
          )
        },
        {
          img: "https://static3.freshin.online/sku/R-bkKOHMCtqp0BVuDovGi%2Bs%2BlQo%3D",
          text: this.$t(
            "home.main.main-bottom-bro.main-bottom-bro-main.single-estate-dairy"
          )
        }
      ];
    }
  },
  methods: {
    changeindex: function(index) {
      this.broNavActive = index;
    }
  }
};
</script>

<style scoped>
body {
  width: 100%;
  height: 100%;
}
.bg {
  background-position: center !important;
  background-image: url(https://static3.freshin.online/sku/KGxwhz37W4qe4PboRnGPcQykBMo%3D);
  /* background-size: 100% 100% !important; */
}
.header-main {
  color: #ffffff;
  margin-top: 4rem;
  text-align: center;
}
.header-main h1 {
  font-size: 3.25rem;
  font-weight: bold;
  margin-bottom: 2.06rem;
}
.header-main h2 {
  font-size: 1.3rem;
  font-weight: normal;
  margin-bottom: 3.63rem;
}
.header-main p {
  font-weight: 300;
  margin-top: 0.5rem;
  font-size: 1rem;
}
.mini-qrcode {
  margin: 0 auto;
  width: 9.56rem;
  height: 9.56rem;
}

.main {
  background-color: #ffffff;
  margin-bottom: 3.8rem;
}
.main-top {
  font-size: 1.36rem;
  padding: 6.25rem 0;
  padding-bottom: 8rem;
}
.main-top-ul {
  padding: 0 5rem;
  display: flex;
  justify-content: space-around;
}
.main-top-ul li {
  text-align: center;
}
.main-top img {
  max-width: 8rem;
  max-height: 8rem;
  margin-bottom: 1.25rem;
}
.main-middle{
  padding:0 2rem;
}
.main-middle-block {
  text-align: center;
}
.main-middle-block-b {
  margin-top: 40px;
  margin-bottom: 88px;
  display: flex;
}
.main-middle-block-b > div {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}
.main-middle > section > h1 {
  font-size: 2.5rem;
  padding: 20px 0;
}
.main-middle > section > h2 {
  font-weight: normal;
  font-size: 1.5rem;
  padding: 1.5rem 0;
  color: rgba(102, 102, 102, 1);
}
.main-middle-block-img img {
  max-width: 100%;
  height: auto;
}
.main-middle-block-text {
  display: flex;
  padding: 0 5%;
  text-align: left;
  background-color: rgba(250, 250, 250, 1);
}
.main-middle-block-text > div {
  align-self: center;
}
.main-middle-block-text h1 {
  font-size: 2rem;
  font-weight: normal;
  padding-bottom: 0.5rem;
}
.main-middle-block-text p {
  font-size: 1.5rem;
  color: rgba(102, 102, 102, 1);
  font-weight: 300;
}
.main-bottom{
  margin-top: 7.63rem;
}
.main-bottom h1 {
  font-size: 2.5rem;
  text-align: center;
  font-weight: normal;
}
.main-bottom-img {
  margin: 2rem 0;
  margin-bottom: 6rem;
  display: flex;
  justify-content: space-between;
}
.main-bottom-img img {
  width: 32%;
  height: 100%;
}
.main-bottom-bro {
  margin-top: 50px;
  font-size: 1.24rem;
}
.main-bottom-bro-main {
  /* min-height: 17rem; */
  margin-top: 1rem;
  margin-bottom: 3.62rem;
  display: flex;
}
.main-bottom-bro-main > img {
  width: 17rem;
  height: 17rem;
}
.main-bottom-bro-main > p {
  white-space: pre-wrap;
  /* width: 75%; */
  font-size: 1.24rem;
  align-self: center;
}
.main-bottom-bro-ul {
  display: flex;
  flex-wrap: wrap;
}
@media screen and (max-width: 768px) {
  .main-bottom-bro-ul li {
    flex: 0 0 33.3%!important;
    width: 33.3% !important;
  }

}
.main-bottom-bro-ul li {
  flex: 0 0 20%;
  width: 20%;
  display: flex;
  opacity: 0.5;
  transition: 1s;
  margin-bottom: 2rem;
  align-items: center;
}
.main-bottom-bro-ul li:last-child {
  width: auto;
  flex: 1;
}
.main-bottom-bro-ul li span {
  align-self: center;
  /* font-weight: 300; */
  font-size: 1.2rem;
}
.broNavListActive {
  opacity: 1 !important;
}
.main-bottom-bro-ul img {
  width: 50%;
  max-width: 5rem;
  max-height: 5rem;
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// home.vue?2949501a